module.exports = __webpack_public_path__ + "img/商厨类碳标签-声明.7213f035.png";